function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function getQueryParameter(param) {
  return new URLSearchParams(window.location.search).get(param) || '';
}

export function getAllQueryParameters() {
  const params = {};
  for (const [key, value] of new URLSearchParams(window.location.search).entries()) {
    params[key] = value;
  }
  return params;
}

export function addQueryParameter(path, param) {
  if (!isObject(param) || Object.keys(param)?.length === 0) return;
  const { key, value } = param;
  if (!key || !value) return;
  const currentParams = new URLSearchParams(window.location.search);
  currentParams.set(key, value);
  window.history.replaceState('', '', `${path}?${currentParams.toString() || ''}`);
}

export function removeQueryParameters(path, paramList) {
  if (!Array.isArray(paramList) || paramList.length === 0) return;
  const currentParams = new URLSearchParams(window.location.search);
  paramList?.forEach((param) => {
    if (currentParams.get(param)) {
      currentParams.delete(param);
    }
  });
  const newParams = currentParams?.toString();
  window.history.replaceState('', '', `${path}${newParams ? `?${newParams}` : ''}`);
}
